export const isEqualArrayBuffers = (buf1: ArrayBuffer, buf2: ArrayBuffer): boolean => {
  if (buf1.byteLength !== buf2.byteLength) return false;
  const a = new Uint8Array(buf1);
  const b = new Uint8Array(buf2);
  return a.every((v, i) => v === b[i]);
};
